import FormattedMessage from 'I18n/components/FormattedMessage';
import unescapedText from 'I18n/utils/unescapedText';
import { getSuperCategoryI18nKey } from 'marketplace-ui-apps-core/common/utils/i18n';
import { getCategoryI18nKey } from 'marketplace-ui-common/utils/i18n';
// @ts-expect-error TODO type
import { titlecase } from '../../../utils/strings';
import { jsx as _jsx } from "react/jsx-runtime";
const ResultsHeaderTitle = ({
  category,
  searchValue,
  superCategory
}) => {
  if (searchValue) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "appMarketplace.storefront.results.resultsPage.headingText.searchResults"
    });
  } else if (superCategory || category) {
    return /*#__PURE__*/_jsx(FormattedMessage, {
      message: "appMarketplace.storefront.filters.category.headingText",
      options: {
        category: titlecase(unescapedText(category ? getCategoryI18nKey(category) : getSuperCategoryI18nKey(superCategory)))
      }
    });
  }
  return /*#__PURE__*/_jsx(FormattedMessage, {
    message: "appMarketplace.storefront.filters.category.items.all.headingText"
  });
};
export default ResultsHeaderTitle;